export function centeringNodeForEnvironment(environmentNodeRef) {
    const rootNode = environmentNodeRef.node || environmentNodeRef;
    let centeringNode = null;
    rootNode.cursor().iterate((nodeRef) => {
        if (centeringNode) {
            return false;
        }
        if (nodeRef.type.name === "CenteringCtrlSeq") {
            centeringNode = nodeRef.node;
            return false;
        }
        if (nodeRef.node !== rootNode && nodeRef.type.is("$Environment")) {
            return false;
        }
        return undefined;
    });
    return centeringNode;
}
